import clsx from 'clsx';
import { components, type GroupBase, type OptionProps } from 'react-select';

import type { dataType } from '../data';
import { useSelectContext } from '../deal';

const { Option } = components;

const IconOption = (
  props: OptionProps<dataType, false, GroupBase<dataType>>
) => {
  const wide = useSelectContext();
  return (
    <Option {...props}>
      <div className="flex items-center gap-2">
        <props.data.Icon className="size-6" />
        <span className={clsx('dark:text-white', !wide && 'sr-only')}>
          {props.data.text}
        </span>
      </div>
    </Option>
  );
};

export { IconOption };
